module.exports = __webpack_public_path__ + "img/sol_isol_pain2.9f5951b1.png";